'use strict';

define('siteObj', function () {
  'use strict';

  return window.siteObj;
});
//# sourceMappingURL=siteObj.js.map
